/**
 *
 * @module entry
 * @desc {SDK.Services.Token} entry point.
 *
 */

import AccessContext from './accessContext';
import AccessToken from './accessToken';
import DeviceGrant from './deviceGrant';
import Grant from './grant';
import IdentityToken from './identityToken';
import RefreshGrant from './refreshGrant';
import TemporaryGrant from './temporaryGrant';
import ExchangeGrant from './exchangeGrant';
import TokenClient from './tokenClient';
import TokenClientConfiguration from './tokenClientConfiguration';
import TokenClientEndpoint from './tokenClientEndpoint';
import TokenClientExtrasMap from './tokenClientExtrasMap';
import TokenRequest from './tokenRequest';
import TokenRequestBuilder from './tokenRequestBuilder';

/**
 *
 * @typedef SDK.Services.Token
 * @type {Object}
 *
 * @property {AccessContext} AccessContext
 * @property {AccessToken} AccessToken
 * @property {DeviceGrant} DeviceGrant
 * @property {Grant} Grant
 * @property {IdentityToken} IdentityToken
 * @property {RefreshGrant} RefreshGrant
 * @property {TemporaryGrant} TemporaryGrant
 * @property {ExchangeGrant} ExchangeGrant
 * @property {TokenClient} TokenClient
 * @property {TokenClientConfiguration} TokenClientConfiguration
 * @property {TokenClientEndpoint} TokenClientEndpoint
 * @property {TokenClientExtrasMap} TokenClientExtrasMap
 * @property {TokenRequest} TokenExchangeRequest
 * @property {TokenRequestBuilder} TokenExchangeRequestBuilder
 *
 */

/**
 *
 * @type {SDK.Services.Token}
 *
 */
export default {

    AccessContext,
    AccessToken,
    DeviceGrant,
    Grant,
    IdentityToken,
    RefreshGrant,
    TemporaryGrant,
    ExchangeGrant,
    TokenClient,
    TokenClientConfiguration,
    TokenClientEndpoint,
    TokenClientExtrasMap,
    TokenRequest,
    TokenRequestBuilder

};



// WEBPACK FOOTER //
// ./src/services/token/entry.js